import { useEffect } from "react";

const SITE = "https://backfillpro.org";

const setAttr = (selector, attr, value) => {
  document.querySelector(selector)?.setAttribute(attr, value);
};

export default function Seo({ title, description, noindex }) {
  useEffect(() => {
    document.title = title;
    const url = SITE + window.location.pathname;
    setAttr('meta[name="description"]', "content", description);
    setAttr('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setAttr('meta[property="og:title"]', "content", title);
    setAttr('meta[property="og:description"]', "content", description);
    setAttr('meta[property="og:url"]', "content", url);
    setAttr('meta[name="twitter:title"]', "content", title);
    setAttr('meta[name="twitter:description"]', "content", description);
    setAttr('link[rel="canonical"]', "href", url);
  }, [title, description, noindex]);
  return null;
}
